import React from "react";
import {
    InvoiceDueDateLabels,
    InvoiceStat,
    InvoiceStatEntity,
    InvoiceStatus,
} from "@common/types/invoice";
import { useEntities } from "@hooks/useEntities";
import { Amount } from "@design-system/Amount/Amount";
import { InvoiceStatus as InvoiceStatusComponent } from "./InvoiceStatus";
import styles from "./InvoiceStatTooltip.module.scss";

interface TooltipContentProps {
    label?: string;
    status: InvoiceStatus;
    stat: InvoiceStat;
    entityStats?: InvoiceStatEntity[];
}

export const InvoiceStatTooltip: React.FC<TooltipContentProps> = ({
    status,
    label,
    stat,
    entityStats,
}) => {
    const subsegments = stat.subsegments;
    const entities = useEntities();
    const entityMap = new Map(entities.map((e) => [e.id, e]));
    return (
        <div className={styles.tooltipContent}>
            <div className={styles.tooltipHeader}>
                <InvoiceStatusComponent
                    status={status}
                    label={label}
                    showText
                    textClassName={styles.tooltipStatusText}
                    className={styles.tooltipStatus}
                />
            </div>

            {subsegments && subsegments.length > 0 && (
                <>
                    <div className={styles.tooltipSubsegments}>
                        {subsegments.map((subsegment) => (
                            <div
                                key={subsegment.label}
                                className={styles.tooltipSubsegment}
                            >
                                <span className={styles.tooltipSubsegmentLabel}>
                                    {InvoiceDueDateLabels[subsegment.label]}
                                </span>
                                <div className={styles.tooltipSubsegmentAmount}>
                                    <Amount amount={subsegment.total} />
                                </div>
                            </div>
                        ))}
                    </div>
                    <hr />
                </>
            )}
            <div className={styles.tooltipSubsegments}>
                {entityStats && entityStats.length > 0 && (
                    <>
                        {entityStats?.map((entity) => (
                            <div
                                key={entity.id}
                                className={styles.tooltipSubsegment}
                            >
                                <span className={styles.tooltipSubsegmentLabel}>
                                    {entityMap.get(entity.id)?.name}
                                </span>
                                <div className={styles.tooltipSubsegmentAmount}>
                                    <Amount amount={entity.total} />
                                </div>
                            </div>
                        ))}
                        <hr />
                    </>
                )}
                <div className={styles.tooltipSubsegment}>
                    <span className={styles.tooltipSubsegmentLabel}>Total</span>
                    <div className={styles.tooltipSubsegmentAmount}>
                        <Amount amount={stat.total} />
                    </div>
                </div>
                <hr />
                <div className={styles.tooltipSubsegment}>
                    <span className={styles.tooltipSubsegmentLabel}>
                        Invoices
                    </span>
                    <div className={styles.tooltipSubsegmentAmount}>
                        {stat.count}
                    </div>
                </div>
            </div>
        </div>
    );
};
